(function( $ ) {
	'use strict';

	go_under.init = function() {
		// Setup some variables that will be useful later
		this.$body       = $( 'body' );
		this.$header     = $( '#wrapper-navbar' );
		this.$wpadminbar = $( '#wpadminbar' );
		this.$main_nav   = $( '#main-nav' );
		this.$mobile_nav = $( '#navbarNavDropdown' );
		this.$nav_toggle = $( '.navbar-toggler' );
		
		// Set a scroll offset to use when doing a scroll to anchor
		this.scroll_offset = this.$header.height() * 2;

		if ( this.$wpadminbar.length ) {
			this.scroll_offset = this.scroll_offset + this.$wpadminbar.height();
		}
		
		// Create a 'resize:debounce' event that we can watch for
		// This allows us to trigger code on window resize without creating a race event
		$( window ).resize( this.debounce( function() {
			$( 'body' ).trigger('resize:debounce');
		}, 13 ) );
		
		// Watch for resize:debounce and trigger debounce actions
		this.$body.on( 'resize:debounce', function( event ) {
			go_under.debounce_actions();
		});
		
		// Hide/show the subscribe ribbon when the nav toggle get's clicked
		this.$nav_toggle.on( 'click', function( event ) {
			$('.subscribe-ribbon').toggle();
			
			// In some situations the mobile menu pushes content down so we rerun debounce immediately after the menu closes
			setTimeout( function () {
		    	go_under.debounce_actions();
		    }, 13 );
		});
		
		// Handle scroll-to links/buttons
		this.$body.find( '.scroll-to' ).on( 'click', function( event ) {
			event.preventDefault();
			go_under.scroll_to( $(this).attr( 'href' ) );
		});
		
		// Add button classes to the view all research menu item
		this.$main_nav.find( '.menu-item-view-all-research a' ).addClass( 'btn btn-primary' ).removeClass( 'dropdown-item' ); 
		
		// Run debounce actions on menu drop down click
		this.$main_nav.find( '.menu-item-has-children a' ).on( 'click', function() {
			go_under.debounce_actions();
		});
		
		// Run stuff
		this.debounce_actions();
		this.nav_search_button();
		this.marketing_cta_buttons();
		this.handle_carousels();
		this.handle_content_images();
		this.handle_case_study_links();
		this.handle_source_value();
		
		if ( this.$body.find( 'article.primary' ).hasClass( 'is-preview' ) ) {
			document.addEventListener( 'contextmenu', function( event ) {
				event.preventDefault();
			});
		}
	};
	
	// Just a basic debounce function
	go_under.debounce = function( callback, wait ) {
		let timer_id;
		return (...args) => {
			clearTimeout(timer_id);
			timer_id = setTimeout(() => {
				callback(...args);
			}, wait);
		};
	};
	
	go_under.scroll_to = function( selector ) {
	    $( 'html, body').animate({
	        scrollTop: $( selector ).offset().top - go_under.scroll_offset
	    }, 500);
	};
	
	// Stuff to do when the resize:debounce event triggers
	go_under.debounce_actions = function() {
		if ( 0 != this.$wpadminbar.length ) {
			this.$header.css( 'margin-top', ( this.$wpadminbar.height() - 1 ) + 'px' );
		}
		
		let header_offset = this.$header.height() - 2;
		
		this.$body.css( 'padding-top', header_offset + 'px' );
		
		if ( 768 <= $(window).width() ) {
			$( '.do-match-heights' ).each(function() {
				$(this).find( '.match-height-1' ).matchHeight();
				$(this).find( '.match-height-2' ).matchHeight();
				$(this).find( '.match-height-3' ).matchHeight();
				$(this).find( '.match-height-4' ).matchHeight();
			})
		}
	};
	
	// Handle search button behavior
	go_under.nav_search_button = function() {
		let $nav_search_form = this.$header.find( '.search-form' );
		let $search_form     = $( '.search .keyword form' );
		
		// Show the header search form when someone clicks the search button
		this.$header.find( '.search-button' ).on( 'click', function( event ) {
			event.preventDefault();

			if ( $search_form.length ) {
				$search_form.find( 'input[type="text"]' ).focus();
				go_under.scroll_to( 'body' );
				return;
			}

			// If the mobile nav is active we need to deactivate it first
			if ( go_under.$mobile_nav.hasClass( 'show' ) ) {
				go_under.$nav_toggle.click();
			}

			$nav_search_form.removeClass( 'd-none' ).find( '.search-field' ).focus();
		});
		
		// Hide the header search form when someone clicks the close search button
		this.$header.find( '.close-search-button' ).on( 'click', function( event ) {
			event.preventDefault();
			
			$nav_search_form.addClass( 'd-none' );
		});
	};
	
	// Handle clicks to the marketing CTA buttons that have forms
	go_under.marketing_cta_buttons = function() {
		$( '.cta-button.has-form' ).on( 'click', function( event ) {
			event.preventDefault();

			let container_id = '#cta-button-form-container-' + $(this).data( 'id' );
			let form_id = '#cta-button-form-' + $(this).data( 'id' );
			let template_id = '#cta-button-form-template-' + $(this).data( 'id' );

			$.featherlight( form_id, {
				persist: 'shared',
				afterOpen: function(event) {
					// Widen this modal beyond Featherlight's default content-driven size,
					// without affecting the image lightbox or the unrelated .active-vendor-modal
					// variant (see .cta-hubspot-modal in _child_theme.scss).
					this.$instance.addClass( 'cta-hubspot-modal' );

					// Some CTAs keep their HubSpot embed inert inside a <template> instead of
					// rendering it eagerly, since certain HubSpot forms (the newer iframe embed)
					// size themselves incorrectly if created while their container is
					// display:none. Inject it now that the modal is actually visible, once.
					//
					// This must go through jQuery's HTML-string append (not a cloned DOM node):
					// a <script> element that was already parsed once by the browser (even inert
					// inside a <template>) carries an "already started" flag that survives
					// cloneNode and silently blocks it from ever executing again. Passing the
					// markup as a string instead routes through jQuery's domManip, which
					// explicitly re-evaluates any <script> tags it finds.
					let $target  = $( form_id );
					let template = document.querySelector( template_id );

					if ( template && ! $target.find( 'script, iframe' ).length ) {
						$target.append( template.innerHTML );
					}
				},
				beforeClose: function(event) {
					$( form_id ).removeClass( 'featherlight-inner' ).appendTo( container_id );
				},
			});
		});
	};

	// Shared HubSpot form loader used by go_misc_hubspot_embed()'s "deferred" mode
	// (class-go-misc.php) — page-builder CTAs can embed many HubSpot forms on one
	// page via render_cta_button()'s <template> mechanism, and duplicating this
	// logic inline in every one of them bloated pages enough to trip a plugin-side
	// (WebToffee cookie consent script blocker) regex/backtrack failure on heavy
	// pages. Centralizing it here means each embed only needs a one-line call.
	//
	// Since this only ever runs from a click handler registered in this same
	// init() pass (marketing_cta_buttons above), go_under is always fully loaded
	// by the time it's called — safe regardless of where the CTA sits on the page.
	go_under.create_hubspot_form = function( args ) {
		function create() {
			hbspt.forms.create( $.extend( {
				region: 'na1',
				portalId: '6337266',
				css: '',
				cssRequired: '',
				onFormReady: go_under.format_hubspot_form,
			}, args ) );
		}

		if ( window.hbspt && window.hbspt.forms ) {
			create();
			return;
		}

		let hs_script = document.querySelector( 'script[src="//js.hsforms.net/forms/embed/v2.js"]' );

		if ( ! hs_script ) {
			hs_script = document.createElement( 'script' );
			hs_script.src = '//js.hsforms.net/forms/embed/v2.js';
			document.head.appendChild( hs_script );
		}

		hs_script.addEventListener( 'load', create );
	};

	// Bootstrap-ify a HubSpot form's markup once it's rendered, and keep doing so
	// as HubSpot's own script mutates the form afterward (validation states, etc).
	go_under.format_hubspot_form = function( $form ) {
		let go_hubspt_update_form = function( $form ) {
			$form.find( 'label' ).addClass( 'form-label' );
			$form.find( 'input[type="text"], input[type="email"], textarea' ).addClass( 'form-control' );
			$form.find( 'select' ).addClass( 'form-select' );
			$form.find( 'input[type="submit"]' ).addClass( 'btn' ).addClass( 'btn-primary' );

			$form.find( 'input[type="checkbox"], input[type="radio"]' ).each(function() {
				$(this).addClass( 'form-check-input' ).removeClass( 'is-invalid' );
				$(this).prependTo( $(this).closest( 'li' ) );
				$(this).closest( 'li' ).addClass( 'form-check' );
				$(this).closest( 'li' ).find( 'label' ).addClass( 'form-check-label' );
			});

			// Validation
			$form.find( '.hs-error-msg' ).addClass( 'invalid-feedback' );
			$form.find( 'input.invalid, textarea.invalid, select.invalid' ).addClass( 'is-invalid' );
			$form.find( 'ul[role="checkbox"].invalid' ).find( 'input' ).addClass( 'is-invalid' );
		};

		go_hubspt_update_form( $form );

		// This is kind of dumb but it prevents a race event
		let go_hubspt_updating = false;

		$form.on('DOMSubtreeModified', function( what ) {
			if ( go_hubspt_updating ) {
				return;
			}

			go_hubspt_updating = true;

			// Short timeout because of delay in hubspot's own script
			setTimeout(function(){
				go_hubspt_update_form( $form );
				go_hubspt_updating = false;
			}, 3);
		});

		// For some reason select changes aren't bubbling up so we gotta watch for it seperately
		$form.on( 'change', 'select', function() {
			setTimeout(function(){
				$form.find( 'select' ).addClass( 'form-select' );
			}, 3);
		});
	};
	
	// Handle the the content carousels
	go_under.handle_carousels = function() {
		if ( ! $( '.go-under-carousel' ).length ) {
			return;
		}

		// Disable the previous button to start
		$( '.go-under-carousel' ).find( '.carousel-control-prev' ).addClass( 'disabled' );
		
		// Make sure the disabled previous button doesn't do anything
		$( '.go-under-carousel' ).find( '.carousel-control-prev.disabled' ).on( 'click', function( event ) {
			event.preventDefault();
		});

		$( '.go-under-carousel' ).on( 'slid.bs.carousel', function( event ) {
			if ( $( event.currentTarget ).find( '.carousel-item:first' ).hasClass('active') ) {
				$( event.currentTarget ).find( '.carousel-control-prev' ).addClass( 'disabled' );
			} else {
				$( event.currentTarget ).find( '.carousel-control-prev' ).removeClass( 'disabled' );
			}

			go_under.debounce_actions();
		});

		// This is the the loading slide template we'll use
		this.$new_slide_template = Handlebars.compile( $( document.getElementById( 'go-under-new-slide-template' ) ).html() );
        
		// Add new content slide when needed
		$( '.go-under-carousel' ).on( 'slide.bs.carousel', function( event ) {
			let last_slide_key = $( event.currentTarget ).find( '.carousel-item' ).length - 1;
        
			// If this is currently the last slide we'll add a new one that's prepped to load more research
			if ( last_slide_key == event.to ) {
				let $template_vars = {
					slide_id: $( event.currentTarget ).attr( 'id' ) + '-slide-' + ( parseInt( event.to ) + 1 ),
					slide_key: ( parseInt( event.to ) + 1 ),
					slide_height: $( event.relatedTarget ).height() - 20
				}
        
				$(event.currentTarget).find( '.carousel-inner' ).append( go_under.$new_slide_template( $template_vars ) );
				go_under.load_carousel_content();
			}
		});
	};
	
	// Get new content for carousels when needed
	go_under.load_carousel_content = function() {
		$( '.go-under-carousel .carousel-item.waiting' ).each( function( index, $item ) {
			$( $item ).removeClass( 'waiting' ).addClass( 'loading' );

			let ajax_action = $( $item ).closest( '.go-under-carousel' ).data( 'ajax-action' );
			let dark        = $( $item ).closest( '.go-under-carousel' ).data( 'dark' );
			let ajax_url    = '/wp-admin/admin-ajax.php?action=' +  ajax_action + '&slide=' + $( $item ).data( 'slide-key' )
						      + '&offset=' + $( $item ).closest( '.go-under-carousel' ).data( 'offset' )
							  + '&target=' + $( $item ).attr( 'id' ) + '&dark=' + dark;

			if ( 'undefined' != typeof $( $item ).closest( '.go-under-carousel' ).data( 'domain' ) ) {
				ajax_url += '&domain=' + $( $item ).closest( '.go-under-carousel' ).data( 'domain' );
			} else if ( 'undefined' != typeof $( $item ).closest( '.go-under-carousel' ).data( 'author' ) ) {
				ajax_url += '&author=' + $( $item ).closest( '.go-under-carousel' ).data( 'author' );
			}

			$.ajax({
				url: ajax_url,
				type: 'GET',
				cache: false,
				dataType: 'json',
				processData: false,
				contentType: false,
			}).done(function( response ) {
				if ( false == response.success ) {
					console.log( response );
				}

				$( response.data.target + ' .row' ).html( response.data.html );
				$( response.data.target ).css( 'min-height', '' );
				$( response.data.target ).removeClass( 'loading' );
			});
		});
	};
	
	// Handle clicks to the marketing CTA buttons that have forms
	go_under.handle_content_images = function() {
		$( '.featherlight-container img:not(.no-featherlight)' ).featherlight({
			targetAttr: 'src',
			root: '#featherlight-modals',
		});
	};
	
	// Handle clicks to the marketing CTA buttons that have forms
	go_under.handle_source_value = function() {
		let source = this.get_get_var( 'go_source' );

		if ( '' == source ) {
			return;
		}
		
		// "go_under=John Doe; expires=Thu, 18 Dec 2013 12:00:00 UTC"
		let date = new Date();
		let exp  = new Date();
		
		exp.setDate( date.getDate() + 7 );

		document.cookie = 'go_source=' + source + '; path=/; expires=' + exp.toUTCString();
	};
	
	// Get cookie by name
	go_under.get_cookie = function( cookie_name ) {
		cookie_name = cookie_name + '=';

		const decoded_cookie = decodeURIComponent( document.cookie );
		const cookie_array   = decoded_cookie.split('; ');

		let cookie_value = '';

		cookie_array.forEach( value => {
			if ( 0 === value.indexOf( cookie_name ) ) {
				cookie_value = value.substring( cookie_name.length );
			}
		} );

		return cookie_value;
	}
	
	// Get GET var
	go_under.get_get_var = function( key ) {
		let get_vars = new URLSearchParams( window.location.search );

		if ( false === get_vars.has( key ) ) {
			return '';
		}

		return get_vars.get( key );
	};
	
	// Handle case study hashtag linking and open associated form
	go_under.handle_case_study_links = function() {
		if ( ! this.$body.hasClass( 'page-case-studies' ) ) {
			return;
		}
		
		if ( '' == window.location.hash ) {
			return;
		}
		
		$( '.case-studies-list .' + window.location.hash.slice(1) + ' .cta-button.has-form' ).click();
	};
	
	$( function() {
		go_under.init();
	});
})( jQuery );